import { CONTRACT_CREATE } from './index';
import { Action } from '../action';

export class ContractCreateInitAction implements Action {
	readonly type = CONTRACT_CREATE.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCreateDestroyAction implements Action {
	readonly type = CONTRACT_CREATE.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCreateClickNextAction implements Action {
	readonly type = CONTRACT_CREATE.CLICK_NEXT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCreateClickPreviousAction implements Action {
	readonly type = CONTRACT_CREATE.CLICK_PREVIOUS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCreateClickFinishAction implements Action {
	readonly type = CONTRACT_CREATE.CLICK_FINISH;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCreateClickAddVehicleAction implements Action {
	readonly type = CONTRACT_CREATE.CLICK_ADD_VEHICLE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCreateClickModifyAction implements Action {
	readonly type = CONTRACT_CREATE.CLICK_MODIFY;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class ContractCreateClickPaymentModeAction implements Action {
	readonly type = CONTRACT_CREATE.CLICK_PAYMENT_MODE;
	constructor(
		public payload: boolean,
		public correlationId?: number
	) {}
}
